import React, { useState } from 'react';
import { 
  Box, 
  Avatar, 
  Typography, 
  Paper, 
  Button, 
  TextField, 
  Select, 
  MenuItem, 
  FormControl, 
  InputLabel 
} from '@mui/material';
import { Header } from "../Header";


const UserProfile = () => {
  const [user, setUser] = useState({
    id: localStorage.getItem('userId') || '',
    name: localStorage.getItem('userName') || '',
    profileImage: '/api/placeholder/150/150', // Placeholder image
    role: localStorage.getItem('userRole') || ''
  });

  return (
    <>
    <Header />
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        p: 4,
        mt: 2,
        margin:'auto', 
        justifyContent:'center', 
        maxWidth: 600, 
        backgroundColor: '#f0f4f8',
        borderRadius: '12px',
        boxShadow: '0 6px 30px rgba(0, 0, 0, 0.1)',
        transition: 'transform 0.2s',
        '&:hover': {
          transform: 'scale(1.02)',
        },
      }}
    >
      <Paper 
        elevation={6} 
        sx={{ 
          p: 4, 
          width: '90%', 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center',
          borderRadius: '10px',
          background: 'linear-gradient(145deg, #ffffff, #f0f0f0)',
          boxShadow: '0 10px 20px rgba(0,0,0,0.1)',
        }}
      >
        <Avatar
          src={user.profileImage}
          alt={user.name || 'User'}
          sx={{ 
            width: 150, 
            height: 150, 
            mb: 3,
            
            border: '4px solid #4CAF50',
            boxShadow: '0 6px 20px rgba(76,175,80,0.4)',
            transition: 'transform 0.3s',
            '&:hover': {
              transform: 'scale(1.05)',
            },
          }}
        />
        
        <Typography variant="h4" gutterBottom sx={{ color: '#2c3e50', fontWeight: 'bold', textAlign: 'center' }}>
          {user.name}
        </Typography>

        

        {/* User ID display moved here */}
        <Box sx={{ mt: 3,  display: 'flex', alignItems: 'center', width: '100%' }}>
          <Typography variant="subtitle1" sx={{ mr: 2, color: '#34495e', fontWeight: 'bold' }}>
          User ID: <span style={{ fontWeight: 'bold', color: '#34495e' }}>{user.id}</span>
        </Typography>
        </Box>

        <Box sx={{ mt: 3,  display: 'flex', alignItems: 'center', width: '100%' }}>
          <Typography variant="subtitle1" sx={{ mr: 2, color: '#34495e', fontWeight: 'bold' }}>
            Role:
          </Typography>
          <Typography variant="body1" sx={{ color: '#34495e', fontWeight: 'bold' }}>{user.role}</Typography>
        </Box>
      </Paper>
    </Box>
    </>
  );
};

export default UserProfile;
